import React from 'react'
import styled from 'styled-components'
import { mixinInputForm } from 'spa/client/styles/mixin'
import { useFormContext } from 'react-hook-form'

export type Props = {
  name: string,
  defaultValue: string,
  options: string[],
} & React.SelectHTMLAttributes<HTMLSelectElement>

const StyledSelect = styled.select`
  ${mixinInputForm}
`

export const StyledSelectForm: React.FC<Props> = (props: Props) => {
  const { register } = useFormContext()

  // TODO react-hook-formを使ったバリデーションエラーメッセージ表示の実装をしたい
  return (
    <StyledSelect defaultValue={props.defaultValue || ""} required={props.required} disabled={props.disabled} {...register(props.name, { required: { value: props.required } })} >
      <option value="" disabled>{props.placeholder || '選択してください'}</option>
      {props.options.map((option: string, index) => (
        <option key={index} value={option}>
          {option}
        </option>
      ))}
    </StyledSelect>
  )
}
